import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  marginFields: {
    marginTop: 15
  },
  card: {
    width: '90%'
  },
  date: {
    marginTop: 15
  }
}));
